import RxMQ from './src/index';

export { EndlessSubject, EndlessReplaySubject, Channel } from './src/index';
export default new RxMQ();
